﻿/* Placeholders.js v4.0.1 */
/*!
 * The MIT License
 *
 * Copyright (c) 2012 James Allardice
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */
!(function (a) {
  'use strict';

  function b() {}

  function c() {
    try {
      return document.activeElement;
    } catch (a) {}
  }

  function d(a, b) {
    for (var c = 0, d = a.length; d > c; c++) if (a[c] === b) return !0;
    return !1;
  }

  function e(a, b, c) {
    return a.addEventListener
      ? a.addEventListener(b, c, !1)
      : a.attachEvent
        ? a.attachEvent('on' + b, c)
        : void 0;
  }

  function f(a, b) {
    var c;
    a.createTextRange
      ? ((c = a.createTextRange()), c.move('character', b), c.select())
      : a.selectionStart && (a.focus(), a.setSelectionRange(b, b));
  }

  function g(a, b) {
    try {
      return (a.type = b), !0;
    } catch (c) {
      return !1;
    }
  }

  function h(a, b) {
    if (a && a.getAttribute(B)) b(a);
    else
      for (
        var c,
          d = a ? a.getElementsByTagName('input') : N,
          e = a ? a.getElementsByTagName('textarea') : O,
          f = d ? d.length : 0,
          g = e ? e.length : 0,
          h = f + g,
          i = 0;
        h > i;
        i++
      )
        (c = f > i ? d[i] : e[i - f]), b(c);
  }

  function i(a) {
    h(a, k);
  }

  function j(a) {
    h(a, l);
  }

  function k(a, b) {
    var c = !!b && a.value !== b,
      d = a.value === a.getAttribute(B);
    if ((c || d) && 'true' === a.getAttribute(C)) {
      a.removeAttribute(C),
        (a.value = a.value.replace(a.getAttribute(B), '')),
        (a.className = a.className.replace(A, ''));
      var e = a.getAttribute(I);
      parseInt(e, 10) >= 0 &&
        (a.setAttribute('maxLength', e), a.removeAttribute(I));
      var f = a.getAttribute(D);
      return f && (a.type = f), !0;
    }
    return !1;
  }

  function l(a) {
    var b = a.getAttribute(B);
    if ('' === a.value && b) {
      a.setAttribute(C, 'true'), (a.value = b), (a.className += ' ' + z);
      var c = a.getAttribute(I);
      c || (a.setAttribute(I, a.maxLength), a.removeAttribute('maxLength'));
      var d = a.getAttribute(D);
      return (
        d
          ? (a.type = 'text')
          : 'password' === a.type &&
            g(a, 'text') &&
            a.setAttribute(D, 'password'),
        !0
      );
    }
    return !1;
  }

  function m(a) {
    return function () {
      P && a.value === a.getAttribute(B) && 'true' === a.getAttribute(C)
        ? f(a, 0)
        : k(a);
    };
  }

  function n(a) {
    return function () {
      l(a);
    };
  }

  function o(a) {
    return function () {
      i(a);
    };
  }

  function p(a) {
    return function (b) {
      return (
        (v = a.value),
        'true' === a.getAttribute(C) &&
        v === a.getAttribute(B) &&
        d(x, b.keyCode)
          ? (b.preventDefault && b.preventDefault(), !1)
          : void 0
      );
    };
  }

  function q(a) {
    return function () {
      k(a, v), '' === a.value && (a.blur(), f(a, 0));
    };
  }

  function r(a) {
    return function () {
      a === c() &&
        a.value === a.getAttribute(B) &&
        'true' === a.getAttribute(C) &&
        f(a, 0);
    };
  }

  function s(a) {
    var b = a.form;
    b &&
      'string' == typeof b &&
      ((b = document.getElementById(b)),
      b.getAttribute(E) || (e(b, 'submit', o(b)), b.setAttribute(E, 'true'))),
      e(a, 'focus', m(a)),
      e(a, 'blur', n(a)),
      P && (e(a, 'keydown', p(a)), e(a, 'keyup', q(a)), e(a, 'click', r(a))),
      a.setAttribute(F, 'true'),
      a.setAttribute(B, T),
      (P || a !== c()) && l(a);
  }

  var t = document.createElement('input'),
    u = void 0 !== t.placeholder;
  if (
    ((a.Placeholders = {
      nativeSupport: u,
      disable: u ? b : i,
      enable: u ? b : j,
    }),
    !u)
  ) {
    var v,
      w = [
        'text',
        'search',
        'url',
        'tel',
        'email',
        'password',
        'number',
        'textarea',
      ],
      x = [27, 33, 34, 35, 36, 37, 38, 39, 40, 8, 46],
      y = '#ccc',
      z = 'placeholdersjs',
      A = new RegExp('(?:^|\\s)' + z + '(?!\\S)'),
      B = 'data-placeholder-value',
      C = 'data-placeholder-active',
      D = 'data-placeholder-type',
      E = 'data-placeholder-submit',
      F = 'data-placeholder-bound',
      G = 'data-placeholder-focus',
      H = 'data-placeholder-live',
      I = 'data-placeholder-maxlength',
      J = 100,
      K = document.getElementsByTagName('head')[0],
      L = document.documentElement,
      M = a.Placeholders,
      N = document.getElementsByTagName('input'),
      O = document.getElementsByTagName('textarea'),
      P = 'false' === L.getAttribute(G),
      Q = 'false' !== L.getAttribute(H),
      R = document.createElement('style');
    R.type = 'text/css';
    var S = document.createTextNode('.' + z + ' {color:' + y + ';}');
    R.styleSheet ? (R.styleSheet.cssText = S.nodeValue) : R.appendChild(S),
      K.insertBefore(R, K.firstChild);
    for (var T, U, V = 0, W = N.length + O.length; W > V; V++)
      (U = V < N.length ? N[V] : O[V - N.length]),
        (T = U.attributes.placeholder),
        T && ((T = T.nodeValue), T && d(w, U.type) && s(U));
    var X = setInterval(function () {
      for (var a = 0, b = N.length + O.length; b > a; a++)
        (U = a < N.length ? N[a] : O[a - N.length]),
          (T = U.attributes.placeholder),
          T
            ? ((T = T.nodeValue),
              T &&
                d(w, U.type) &&
                (U.getAttribute(F) || s(U),
                (T !== U.getAttribute(B) ||
                  ('password' === U.type && !U.getAttribute(D))) &&
                  ('password' === U.type &&
                    !U.getAttribute(D) &&
                    g(U, 'text') &&
                    U.setAttribute(D, 'password'),
                  U.value === U.getAttribute(B) && (U.value = T),
                  U.setAttribute(B, T))))
            : U.getAttribute(C) && (k(U), U.removeAttribute(B));
      Q || clearInterval(X);
    }, J);
    e(a, 'beforeunload', function () {
      M.disable();
    });
  }
})(window);

(function (a, b) {
  'use strict';
  var c = a.fn.val,
    d = a.fn.prop;
  b.Placeholders.nativeSupport ||
    ((a.fn.val = function (a) {
      var b = c.apply(this, arguments),
        d = this.eq(0).data('placeholder-value');
      return void 0 === a && this.eq(0).data('placeholder-active') && b === d
        ? ''
        : b;
    }),
    (a.fn.prop = function (a, b) {
      return void 0 === b &&
        this.eq(0).data('placeholder-active') &&
        'value' === a
        ? ''
        : d.apply(this, arguments);
    }));
})(jQuery, window);

!(function (window) {
  'use strict';

  function classReg(className) {
    return new RegExp('(^|\\s+)' + className + '(\\s+|$)');
  }

  function toggleClass(elem, c) {
    (hasClass(elem, c) ? removeClass : addClass)(elem, c);
  }

  var hasClass, addClass, removeClass;
  'classList' in document.documentElement
    ? ((hasClass = function (elem, c) {
        return elem.classList.contains(c);
      }),
      (addClass = function (elem, c) {
        elem.classList.add(c);
      }),
      (removeClass = function (elem, c) {
        elem.classList.remove(c);
      }))
    : ((hasClass = function (elem, c) {
        return classReg(c).test(elem.className);
      }),
      (addClass = function (elem, c) {
        hasClass(elem, c) || (elem.className = elem.className + ' ' + c);
      }),
      (removeClass = function (elem, c) {
        elem.className = elem.className.replace(classReg(c), ' ');
      }));
  var classie = {
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    toggleClass: toggleClass,
    has: hasClass,
    add: addClass,
    remove: removeClass,
    toggle: toggleClass,
  };
  'function' == typeof define && define.amd
    ? define(classie)
    : 'object' == typeof exports
      ? (module.exports = classie)
      : (window.classie = classie);
})(window);

var SidebarMenuEffects = (function () {
  function hasParentClass(e, classname) {
    return (
      e !== document &&
      (!!classie.has(e, classname) ||
        (e.parentNode && hasParentClass(e.parentNode, classname)))
    );
  }

  function mobilecheck() {
    var check = !1;
    return ((function(aa) {
        (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(aa) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(aa.substr(0, 4))) && (check = !0);
      }
    )(navigator.userAgent || navigator.vendor || window.opera),
      check);
  }

  function init() {
    var container = document.getElementById('st-container'),
      buttons = Array.prototype.slice.call(
        document.querySelectorAll('#st-trigger-effects > span.browse'),
      ),
      eventtype = mobilecheck() ? 'touchstart' : 'click',
      resetMenu = function () {
        classie.remove(container, 'st-menu-open'),
          $('.nav li.mbl .close-menu').removeClass('active'),
          $('.nav li.mbl span.browse').removeClass('disabled');
      },
      bodyClickFn = function (evt) {
        hasParentClass(evt.target, 'st-menu') ||
          (resetMenu(), document.removeEventListener(eventtype, bodyClickFn)),
          hasParentClass(evt.target, 'close-nav') &&
            (resetMenu(), document.removeEventListener(eventtype, bodyClickFn));
      };
    buttons.forEach(function (el, i) {
      var effect = el.getAttribute('data-effect');
      el.addEventListener(eventtype, function (ev) {
        ev.stopPropagation(),
          ev.preventDefault(),
          (container.className = 'st-container'),
          classie.add(container, effect),
          $('.nav li.mbl .close-menu').addClass('active'),
          $('.nav li.mbl span.browse').addClass('disabled'),
          setTimeout(function () {
            classie.add(container, 'st-menu-open');
          }, 25),
          document.addEventListener(eventtype, bodyClickFn);
      });
    });
  }

  init();
})();

!(function (undefined) {
  'use strict';

  function addEventListener(el, evt, func) {
    'addEventListener' in window
      ? el.addEventListener(evt, func, !1)
      : 'attachEvent' in window && el.attachEvent('on' + evt, func);
  }

  function removeEventListener(el, evt, func) {
    'removeEventListener' in window
      ? el.removeEventListener(evt, func, !1)
      : 'detachEvent' in window && el.detachEvent('on' + evt, func);
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function throttle(func) {
    var context,
      args,
      result,
      timeout = null,
      previous = 0,
      later = function () {
        (previous = getNow()),
          (timeout = null),
          (result = func.apply(context, args)),
          timeout || (context = args = null);
      };
    return function () {
      var now = getNow();
      previous || (previous = now);
      var remaining = throttledTimer - (now - previous);
      return (
        (context = this),
        (args = arguments),
        remaining <= 0 || remaining > throttledTimer
          ? (timeout && (clearTimeout(timeout), (timeout = null)),
            (previous = now),
            (result = func.apply(context, args)),
            timeout || (context = args = null))
          : timeout || (timeout = setTimeout(later, remaining)),
        result
      );
    };
  }

  function formatLogMsg(msg) {
    return msgID + '[' + myID + '] ' + msg;
  }

  function log(msg) {
    logging &&
      'object' == typeof window.console &&
      console.log(formatLogMsg(msg));
  }

  function warn(msg) {
    'object' == typeof window.console && console.warn(formatLogMsg(msg));
  }

  function init() {
    readDataFromParent(),
      log('Initialising iFrame (' + location.href + ')'),
      readDataFromPage(),
      setMargin(),
      setBodyStyle('background', bodyBackground),
      setBodyStyle('padding', bodyPadding),
      injectClearFixIntoBodyElement(),
      checkHeightMode(),
      checkWidthMode(),
      stopInfiniteResizingOfIFrame(),
      setupPublicMethods(),
      startEventListeners(),
      (inPageLinks = setupInPageLinks()),
      sendSize('init', 'Init message from host page'),
      readyCallback();
  }

  function readDataFromParent() {
    function strBool(str) {
      return 'true' === str;
    }

    var data = initMsg.substr(msgIdLen).split(':');
    (myID = data[0]),
      (bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin),
      (calculateWidth =
        undefined !== data[2] ? strBool(data[2]) : calculateWidth),
      (logging = undefined !== data[3] ? strBool(data[3]) : logging),
      (interval = undefined !== data[4] ? Number(data[4]) : interval),
      (autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize),
      (bodyMarginStr = data[7]),
      (heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode),
      (bodyBackground = data[9]),
      (bodyPadding = data[10]),
      (tolerance = undefined !== data[11] ? Number(data[11]) : tolerance),
      (inPageLinks.enable = undefined !== data[12] && strBool(data[12])),
      (resizeFrom = undefined !== data[13] ? data[13] : resizeFrom),
      (widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode);
  }

  function readDataFromPage() {
    function readData() {
      var data = window.iFrameResizer;
      log('Reading data from page: ' + JSON.stringify(data)),
        (messageCallback =
          'messageCallback' in data ? data.messageCallback : messageCallback),
        (readyCallback =
          'readyCallback' in data ? data.readyCallback : readyCallback),
        (targetOriginDefault =
          'targetOrigin' in data ? data.targetOrigin : targetOriginDefault),
        (heightCalcMode =
          'heightCalculationMethod' in data
            ? data.heightCalculationMethod
            : heightCalcMode),
        (widthCalcMode =
          'widthCalculationMethod' in data
            ? data.widthCalculationMethod
            : widthCalcMode);
    }

    function setupCustomCalcMethods(calcMode, calcFunc) {
      return (
        'function' == typeof calcMode &&
          (log('Setup custom ' + calcFunc + 'CalcMethod'),
          (customCalcMethods[calcFunc] = calcMode),
          (calcMode = 'custom')),
        calcMode
      );
    }

    'iFrameResizer' in window &&
      Object === window.iFrameResizer.constructor &&
      (readData(),
      (heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height')),
      (widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width'))),
      log('TargetOrigin for parent set to: ' + targetOriginDefault);
  }

  function chkCSS(attr, value) {
    return (
      -1 !== value.indexOf('-') &&
        (warn('Negative CSS value ignored for ' + attr), (value = '')),
      value
    );
  }

  function setBodyStyle(attr, value) {
    undefined !== value &&
      '' !== value &&
      'null' !== value &&
      ((document.body.style[attr] = value),
      log('Body ' + attr + ' set to "' + value + '"'));
  }

  function setMargin() {
    undefined === bodyMarginStr && (bodyMarginStr = bodyMargin + 'px'),
      setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
  }

  function stopInfiniteResizingOfIFrame() {
    (document.documentElement.style.height = ''),
      (document.body.style.height = ''),
      log('HTML & body height set to "auto"');
  }

  function manageTriggerEvent(options) {
    var listener = {
      add: function (eventName) {
        function handleEvent() {
          sendSize(options.eventName, options.eventType);
        }

        (eventHandlersByName[eventName] = handleEvent),
          addEventListener(window, eventName, handleEvent);
      },
      remove: function (eventName) {
        var handleEvent = eventHandlersByName[eventName];
        delete eventHandlersByName[eventName],
          removeEventListener(window, eventName, handleEvent);
      },
    };
    options.eventNames && Array.prototype.map
      ? ((options.eventName = options.eventNames[0]),
        options.eventNames.map(listener[options.method]))
      : listener[options.method](options.eventName),
      log(
        capitalizeFirstLetter(options.method) +
          ' event listener: ' +
          options.eventType,
      );
  }

  function manageEventListeners(method) {
    manageTriggerEvent({
      method: method,
      eventType: 'Animation Start',
      eventNames: ['animationstart', 'webkitAnimationStart'],
    }),
      manageTriggerEvent({
        method: method,
        eventType: 'Animation Iteration',
        eventNames: ['animationiteration', 'webkitAnimationIteration'],
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Animation End',
        eventNames: ['animationend', 'webkitAnimationEnd'],
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Input',
        eventName: 'input',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Mouse Up',
        eventName: 'mouseup',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Mouse Down',
        eventName: 'mousedown',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Orientation Change',
        eventName: 'orientationchange',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Print',
        eventName: ['afterprint', 'beforeprint'],
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Ready State Change',
        eventName: 'readystatechange',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Touch Start',
        eventName: 'touchstart',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Touch End',
        eventName: 'touchend',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Touch Cancel',
        eventName: 'touchcancel',
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Transition Start',
        eventNames: [
          'transitionstart',
          'webkitTransitionStart',
          'MSTransitionStart',
          'oTransitionStart',
          'otransitionstart',
        ],
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Transition Iteration',
        eventNames: [
          'transitioniteration',
          'webkitTransitionIteration',
          'MSTransitionIteration',
          'oTransitionIteration',
          'otransitioniteration',
        ],
      }),
      manageTriggerEvent({
        method: method,
        eventType: 'Transition End',
        eventNames: [
          'transitionend',
          'webkitTransitionEnd',
          'MSTransitionEnd',
          'oTransitionEnd',
          'otransitionend',
        ],
      }),
      'child' === resizeFrom &&
        manageTriggerEvent({
          method: method,
          eventType: 'IFrame Resized',
          eventName: 'resize',
        });
  }

  function checkCalcMode(calcMode, calcModeDefault, modes, type) {
    return (
      calcModeDefault !== calcMode &&
        (calcMode in modes ||
          (warn(
            calcMode +
              ' is not a valid option for ' +
              type +
              'CalculationMethod.',
          ),
          (calcMode = calcModeDefault)),
        log(type + ' calculation method set to "' + calcMode + '"')),
      calcMode
    );
  }

  function checkHeightMode() {
    heightCalcMode = checkCalcMode(
      heightCalcMode,
      heightCalcModeDefault,
      getHeight,
      'height',
    );
  }

  function checkWidthMode() {
    widthCalcMode = checkCalcMode(
      widthCalcMode,
      widthCalcModeDefault,
      getWidth,
      'width',
    );
  }

  function startEventListeners() {
    !0 === autoResize
      ? (manageEventListeners('add'), setupMutationObserver())
      : log('Auto Resize disabled');
  }

  function stopMsgsToParent() {
    log('Disable outgoing messages'), (sendPermit = !1);
  }

  function removeMsgListener() {
    log('Remove event listener: Message'),
      removeEventListener(window, 'message', receiver);
  }

  function disconnectMutationObserver() {
    null !== bodyObserver && bodyObserver.disconnect();
  }

  function stopEventListeners() {
    manageEventListeners('remove'),
      disconnectMutationObserver(),
      clearInterval(intervalTimer);
  }

  function teardown() {
    stopMsgsToParent(),
      removeMsgListener(),
      !0 === autoResize && stopEventListeners();
  }

  function injectClearFixIntoBodyElement() {
    var clearFix = document.createElement('div');
    (clearFix.style.clear = 'both'),
      (clearFix.style.display = 'block'),
      document.body.appendChild(clearFix);
  }

  function setupInPageLinks() {
    function getPagePosition() {
      return {
        x:
          window.pageXOffset !== undefined
            ? window.pageXOffset
            : document.documentElement.scrollLeft,
        y:
          window.pageYOffset !== undefined
            ? window.pageYOffset
            : document.documentElement.scrollTop,
      };
    }

    function getElementPosition(el) {
      var elPosition = el.getBoundingClientRect(),
        pagePosition = getPagePosition();
      return {
        x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
        y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10),
      };
    }

    function findTarget(location) {
      function jumpToTarget(target) {
        var jumpPosition = getElementPosition(target);
        log(
          'Moving to in page link (#' +
            hash +
            ') at x: ' +
            jumpPosition.x +
            ' y: ' +
            jumpPosition.y,
        ),
          sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset');
      }

      var hash = location.split('#')[1] || location,
        hashData = decodeURIComponent(hash),
        target =
          document.getElementById(hashData) ||
          document.getElementsByName(hashData)[0];
      undefined !== target
        ? jumpToTarget(target)
        : (log(
            'In page link (#' +
              hash +
              ') not found in iFrame, so sending to parent',
          ),
          sendMsg(0, 0, 'inPageLink', '#' + hash));
    }

    function checkLocationHash() {
      '' !== location.hash &&
        '#' !== location.hash &&
        findTarget(location.href);
    }

    function bindAnchors() {
      function setupLink(el) {
        function linkClicked(e) {
          e.preventDefault(), findTarget(this.getAttribute('href'));
        }

        '#' !== el.getAttribute('href') &&
          addEventListener(el, 'click', linkClicked);
      }

      Array.prototype.forEach.call(
        document.querySelectorAll('a[href^="#"]'),
        setupLink,
      );
    }

    function bindLocationHash() {
      addEventListener(window, 'hashchange', checkLocationHash);
    }

    function initCheck() {
      setTimeout(checkLocationHash, eventCancelTimer);
    }

    function enableInPageLinks() {
      Array.prototype.forEach && document.querySelectorAll
        ? (log('Setting up location.hash handlers'),
          bindAnchors(),
          bindLocationHash(),
          initCheck())
        : warn(
            'In page linking not fully supported in this browser! (See README.md for IE8 workaround)',
          );
    }

    return (
      inPageLinks.enable
        ? enableInPageLinks()
        : log('In page linking not enabled'),
      { findTarget: findTarget }
    );
  }

  function setupPublicMethods() {
    log('Enable public methods'),
      (win.parentIFrame = {
        autoResize: function (resize) {
          return (
            !0 === resize && !1 === autoResize
              ? ((autoResize = !0), startEventListeners())
              : !1 === resize &&
                !0 === autoResize &&
                ((autoResize = !1), stopEventListeners()),
            autoResize
          );
        },
        close: function () {
          sendMsg(0, 0, 'close'), teardown();
        },
        getId: function () {
          return myID;
        },
        getPageInfo: function (callback) {
          'function' == typeof callback
            ? ((pageInfoCallback = callback), sendMsg(0, 0, 'pageInfo'))
            : ((pageInfoCallback = function () {}),
              sendMsg(0, 0, 'pageInfoStop'));
        },
        moveToAnchor: function (hash) {
          inPageLinks.findTarget(hash);
        },
        reset: function () {
          resetIFrame('parentIFrame.reset');
        },
        scrollTo: function (x, y) {
          sendMsg(y, x, 'scrollTo');
        },
        scrollToOffset: function (x, y) {
          sendMsg(y, x, 'scrollToOffset');
        },
        sendMessage: function (msg, targetOrigin) {
          sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
        },
        setHeightCalculationMethod: function (heightCalculationMethod) {
          (heightCalcMode = heightCalculationMethod), checkHeightMode();
        },
        setWidthCalculationMethod: function (widthCalculationMethod) {
          (widthCalcMode = widthCalculationMethod), checkWidthMode();
        },
        setTargetOrigin: function (targetOrigin) {
          log('Set targetOrigin: ' + targetOrigin),
            (targetOriginDefault = targetOrigin);
        },
        size: function (customHeight, customWidth) {
          sendSize(
            'size',
            'parentIFrame.size(' +
              (customHeight || '') +
              (customWidth ? ',' + customWidth : '') +
              ')',
            customHeight,
            customWidth,
          );
        },
      });
  }

  function initInterval() {
    0 !== interval &&
      (log('setInterval: ' + interval + 'ms'),
      (intervalTimer = setInterval(function () {
        sendSize('interval', 'setInterval: ' + interval);
      }, Math.abs(interval))));
  }

  function setupBodyMutationObserver() {
    function addImageLoadListners(mutation) {
      function addImageLoadListener(element) {
        !1 === element.complete &&
          (log('Attach listeners to ' + element.src),
          element.addEventListener('load', imageLoaded, !1),
          element.addEventListener('error', imageError, !1),
          elements.push(element));
      }

      'attributes' === mutation.type && 'src' === mutation.attributeName
        ? addImageLoadListener(mutation.target)
        : 'childList' === mutation.type &&
          Array.prototype.forEach.call(
            mutation.target.querySelectorAll('img'),
            addImageLoadListener,
          );
    }

    function removeFromArray(element) {
      elements.splice(elements.indexOf(element), 1);
    }

    function removeImageLoadListener(element) {
      log('Remove listeners from ' + element.src),
        element.removeEventListener('load', imageLoaded, !1),
        element.removeEventListener('error', imageError, !1),
        removeFromArray(element);
    }

    function imageEventTriggered(event, type, typeDesc) {
      removeImageLoadListener(event.target),
        sendSize(
          type,
          typeDesc + ': ' + event.target.src,
          undefined,
          undefined,
        );
    }

    function imageLoaded(event) {
      imageEventTriggered(event, 'imageLoad', 'Image loaded');
    }

    function imageError(event) {
      imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
    }

    function mutationObserved(mutations) {
      sendSize(
        'mutationObserver',
        'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type,
      ),
        mutations.forEach(addImageLoadListners);
    }

    function createMutationObserver() {
      var target = document.querySelector('body'),
        config = {
          attributes: !0,
          attributeOldValue: !1,
          characterData: !0,
          characterDataOldValue: !1,
          childList: !0,
          subtree: !0,
        };
      return (
        (observer = new MutationObserver(mutationObserved)),
        log('Create body MutationObserver'),
        observer.observe(target, config),
        observer
      );
    }

    var elements = [],
      MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver,
      observer = createMutationObserver();
    return {
      disconnect: function () {
        'disconnect' in observer &&
          (log('Disconnect body MutationObserver'),
          observer.disconnect(),
          elements.forEach(removeImageLoadListener));
      },
    };
  }

  function setupMutationObserver() {
    var forceIntervalTimer = 0 > interval;
    window.MutationObserver || window.WebKitMutationObserver
      ? forceIntervalTimer
        ? initInterval()
        : (bodyObserver = setupBodyMutationObserver())
      : (log('MutationObserver not supported in this browser!'),
        initInterval());
  }

  function getComputedStyle(prop, el) {
    function convertUnitsToPxForIE8(value) {
      if (/^\d+(px)?$/i.test(value)) return parseInt(value, base);
      var style = el.style.left,
        runtimeStyle = el.runtimeStyle.left;
      return (
        (el.runtimeStyle.left = el.currentStyle.left),
        (el.style.left = value || 0),
        (value = el.style.pixelLeft),
        (el.style.left = style),
        (el.runtimeStyle.left = runtimeStyle),
        value
      );
    }

    var retVal = 0;
    return (
      (el = el || document.body),
      'defaultView' in document && 'getComputedStyle' in document.defaultView
        ? ((retVal = document.defaultView.getComputedStyle(el, null)),
          (retVal = null !== retVal ? retVal[prop] : 0))
        : (retVal = convertUnitsToPxForIE8(el.currentStyle[prop])),
      parseInt(retVal, base)
    );
  }

  function chkEventThottle(timer) {
    timer > throttledTimer / 2 &&
      ((throttledTimer = 2 * timer),
      log('Event throttle increased to ' + throttledTimer + 'ms'));
  }

  function getMaxElement(side, elements) {
    for (
      var elementsLength = elements.length,
        elVal = 0,
        maxVal = 0,
        Side = capitalizeFirstLetter(side),
        timer = getNow(),
        i = 0;
      i < elementsLength;
      i++
    )
      (elVal =
        elements[i].getBoundingClientRect()[side] +
        getComputedStyle('margin' + Side, elements[i])) > maxVal &&
        (maxVal = elVal);
    return (
      (timer = getNow() - timer),
      log('Parsed ' + elementsLength + ' HTML elements'),
      log('Element position calculated in ' + timer + 'ms'),
      chkEventThottle(timer),
      maxVal
    );
  }

  function getAllMeasurements(dimention) {
    return [
      dimention.bodyOffset(),
      dimention.bodyScroll(),
      dimention.documentElementOffset(),
      dimention.documentElementScroll(),
    ];
  }

  function getTaggedElements(side, tag) {
    function noTaggedElementsFound() {
      return (
        warn('No tagged elements (' + tag + ') found on page'),
        document.querySelectorAll('body *')
      );
    }

    var elements = document.querySelectorAll('[' + tag + ']');
    return (
      0 === elements.length && noTaggedElementsFound(),
      getMaxElement(side, elements)
    );
  }

  function getAllElements() {
    return document.querySelectorAll('body *');
  }

  function sizeIFrame(
    triggerEvent,
    triggerEventDesc,
    customHeight,
    customWidth,
  ) {
    function resizeIFrame() {
      (height = currentHeight),
        (width = currentWidth),
        sendMsg(height, width, triggerEvent);
    }

    function isSizeChangeDetected() {
      function checkTolarance(a, b) {
        return !(Math.abs(a - b) <= tolerance);
      }

      return (
        (currentHeight =
          undefined !== customHeight
            ? customHeight
            : getHeight[heightCalcMode]()),
        (currentWidth =
          undefined !== customWidth ? customWidth : getWidth[widthCalcMode]()),
        checkTolarance(height, currentHeight) ||
          (calculateWidth && checkTolarance(width, currentWidth))
      );
    }

    function isForceResizableEvent() {
      return !(triggerEvent in { init: 1, interval: 1, size: 1 });
    }

    function isForceResizableCalcMode() {
      return (
        heightCalcMode in resetRequiredMethods ||
        (calculateWidth && widthCalcMode in resetRequiredMethods)
      );
    }

    function logIgnored() {
      log('No change in size detected');
    }

    function checkDownSizing() {
      isForceResizableEvent() && isForceResizableCalcMode()
        ? resetIFrame(triggerEventDesc)
        : triggerEvent in { interval: 1 } || logIgnored();
    }

    var currentHeight, currentWidth;
    isSizeChangeDetected() || 'init' === triggerEvent
      ? (lockTrigger(), resizeIFrame())
      : checkDownSizing();
  }

  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
    function recordTrigger() {
      triggerEvent in { reset: 1, resetPage: 1, init: 1 } ||
        log('Trigger event: ' + triggerEventDesc);
    }

    function isDoubleFiredEvent() {
      return triggerLocked && triggerEvent in doubleEventList;
    }

    isDoubleFiredEvent()
      ? log('Trigger event cancelled: ' + triggerEvent)
      : (recordTrigger(),
        'init' === triggerEvent
          ? sizeIFrame(
              triggerEvent,
              triggerEventDesc,
              customHeight,
              customWidth,
            )
          : sizeIFrameThrottled(
              triggerEvent,
              triggerEventDesc,
              customHeight,
              customWidth,
            ));
  }

  function lockTrigger() {
    triggerLocked || ((triggerLocked = !0), log('Trigger event lock on')),
      clearTimeout(triggerLockedTimer),
      (triggerLockedTimer = setTimeout(function () {
        (triggerLocked = !1), log('Trigger event lock off'), log('--');
      }, eventCancelTimer));
  }

  function triggerReset(triggerEvent) {
    (height = getHeight[heightCalcMode]()),
      (width = getWidth[widthCalcMode]()),
      sendMsg(height, width, triggerEvent);
  }

  function resetIFrame(triggerEventDesc) {
    var hcm = heightCalcMode;
    (heightCalcMode = heightCalcModeDefault),
      log('Reset trigger event: ' + triggerEventDesc),
      lockTrigger(),
      triggerReset('reset'),
      (heightCalcMode = hcm);
  }

  function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
    function setTargetOrigin() {
      undefined === targetOrigin
        ? (targetOrigin = targetOriginDefault)
        : log('Message targetOrigin: ' + targetOrigin);
    }

    function sendToParent() {
      var size = height + ':' + width,
        message =
          myID +
          ':' +
          size +
          ':' +
          triggerEvent +
          (undefined !== msg ? ':' + msg : '');
      log('Sending message to host page (' + message + ')'),
        target.postMessage(msgID + message, targetOrigin);
    }

    !0 === sendPermit && (setTargetOrigin(), sendToParent());
  }

  function receiver(event) {
    function isMessageForUs() {
      return msgID === ('' + event.data).substr(0, msgIdLen);
    }

    function getMessageType() {
      return event.data.split(']')[1].split(':')[0];
    }

    function getData() {
      return event.data.substr(event.data.indexOf(':') + 1);
    }

    function isMiddleTier() {
      return (
        !('undefined' != typeof module && module.exports) &&
        'iFrameResize' in window
      );
    }

    function isInitMsg() {
      return event.data.split(':')[2] in { true: 1, false: 1 };
    }

    function callFromParent() {
      var messageType = getMessageType();
      messageType in processRequestFromParent
        ? processRequestFromParent[messageType]()
        : isMiddleTier() ||
          isInitMsg() ||
          warn('Unexpected message (' + event.data + ')');
    }

    function processMessage() {
      !1 === firstRun
        ? callFromParent()
        : isInitMsg()
          ? processRequestFromParent.init()
          : log(
              'Ignored message of type "' +
                getMessageType() +
                '". Received before initialization.',
            );
    }

    var processRequestFromParent = {
      init: function () {
        function fireInit() {
          (initMsg = event.data),
            (target = event.source),
            init(),
            (firstRun = !1),
            setTimeout(function () {
              initLock = !1;
            }, eventCancelTimer);
        }

        'interactive' === document.readyState ||
        'complete' === document.readyState
          ? fireInit()
          : (log('Waiting for page ready'),
            addEventListener(
              window,
              'readystatechange',
              processRequestFromParent.initFromParent,
            ));
      },
      reset: function () {
        initLock
          ? log('Page reset ignored by init')
          : (log('Page size reset by host page'), triggerReset('resetPage'));
      },
      resize: function () {
        sendSize('resizeParent', 'Parent window requested size check');
      },
      moveToAnchor: function () {
        inPageLinks.findTarget(getData());
      },
      inPageLink: function () {
        this.moveToAnchor();
      },
      pageInfo: function () {
        var msgBody = getData();
        log('PageInfoFromParent called from parent: ' + msgBody),
          pageInfoCallback(JSON.parse(msgBody)),
          log(' --');
      },
      message: function () {
        var msgBody = getData();
        log('MessageCallback called from parent: ' + msgBody),
          messageCallback(JSON.parse(msgBody)),
          log(' --');
      },
    };
    isMessageForUs() && processMessage();
  }

  function chkLateLoaded() {
    'loading' !== document.readyState &&
      window.parent.postMessage('[iFrameResizerChild]Ready', '*');
  }

  if ('undefined' != typeof window) {
    var autoResize = !0,
      base = 10,
      bodyBackground = '',
      bodyMargin = 0,
      bodyMarginStr = '',
      bodyObserver = null,
      bodyPadding = '',
      calculateWidth = !1,
      doubleEventList = { resize: 1, click: 1 },
      eventCancelTimer = 128,
      firstRun = !0,
      height = 1,
      heightCalcModeDefault = 'bodyOffset',
      heightCalcMode = heightCalcModeDefault,
      initLock = !0,
      initMsg = '',
      inPageLinks = {},
      interval = 32,
      intervalTimer = null,
      logging = !1,
      msgID = '[iFrameSizer]',
      msgIdLen = msgID.length,
      myID = '',
      resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1,
      },
      resizeFrom = 'child',
      sendPermit = !0,
      target = window.parent,
      targetOriginDefault = '*',
      tolerance = 0,
      triggerLocked = !1,
      triggerLockedTimer = null,
      throttledTimer = 16,
      width = 1,
      widthCalcModeDefault = 'scroll',
      widthCalcMode = widthCalcModeDefault,
      win = window,
      messageCallback = function () {
        warn('MessageCallback function not defined');
      },
      readyCallback = function () {},
      pageInfoCallback = function () {},
      customCalcMethods = {
        height: function () {
          return (
            warn('Custom height calculation function not defined'),
            document.documentElement.offsetHeight
          );
        },
        width: function () {
          return (
            warn('Custom width calculation function not defined'),
            document.body.scrollWidth
          );
        },
      },
      eventHandlersByName = {},
      getNow =
        Date.now ||
        function () {
          return new Date().getTime();
        },
      getHeight = {
        bodyOffset: function () {
          return (
            document.body.offsetHeight +
            getComputedStyle('marginTop') +
            getComputedStyle('marginBottom')
          );
        },
        offset: function () {
          return getHeight.bodyOffset();
        },
        bodyScroll: function () {
          return document.body.scrollHeight;
        },
        custom: function () {
          return customCalcMethods.height();
        },
        documentElementOffset: function () {
          return document.documentElement.offsetHeight;
        },
        documentElementScroll: function () {
          return document.documentElement.scrollHeight;
        },
        max: function () {
          return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function () {
          return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function () {
          return getHeight.max();
        },
        lowestElement: function () {
          return Math.max(
            getHeight.bodyOffset() || getHeight.documentElementOffset(),
            getMaxElement('bottom', getAllElements()),
          );
        },
        taggedElement: function () {
          return getTaggedElements('bottom', 'data-iframe-height');
        },
      },
      getWidth = {
        bodyScroll: function () {
          return document.body.scrollWidth;
        },
        bodyOffset: function () {
          return document.body.offsetWidth;
        },
        custom: function () {
          return customCalcMethods.width();
        },
        documentElementScroll: function () {
          return document.documentElement.scrollWidth;
        },
        documentElementOffset: function () {
          return document.documentElement.offsetWidth;
        },
        scroll: function () {
          return Math.max(
            getWidth.bodyScroll(),
            getWidth.documentElementScroll(),
          );
        },
        max: function () {
          return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function () {
          return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function () {
          return getMaxElement('right', getAllElements());
        },
        taggedElement: function () {
          return getTaggedElements('right', 'data-iframe-width');
        },
      },
      sizeIFrameThrottled = throttle(sizeIFrame);
    addEventListener(window, 'message', receiver), chkLateLoaded();
  }
})();
(function (undefined) {
    'use strict';

    function addEventListener(obj, evt, func) {
      'addEventListener' in window
        ? obj.addEventListener(evt, func, !1)
        : 'attachEvent' in window && obj.attachEvent('on' + evt, func);
    }

    function removeEventListener(el, evt, func) {
      'removeEventListener' in window
        ? el.removeEventListener(evt, func, !1)
        : 'detachEvent' in window && el.detachEvent('on' + evt, func);
    }

    function setupRequestAnimationFrame() {
      var x,
        vendors = ['moz', 'webkit', 'o', 'ms'];
      for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1)
        requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      requestAnimationFrame ||
        log('setup', 'RequestAnimationFrame not supported');
    }

    function getMyID(iframeId) {
      var retStr = 'Host page: ' + iframeId;
      return (
        window.top !== window.self &&
          (retStr =
            window.parentIFrame && window.parentIFrame.getId
              ? window.parentIFrame.getId() + ': ' + iframeId
              : 'Nested host page: ' + iframeId),
        retStr
      );
    }

    function formatLogHeader(iframeId) {
      return msgId + '[' + getMyID(iframeId) + ']';
    }

    function isLogEnabled(iframeId) {
      return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }

    function log(iframeId, msg) {
      output('log', iframeId, msg, isLogEnabled(iframeId));
    }

    function info(iframeId, msg) {
      output('info', iframeId, msg, isLogEnabled(iframeId));
    }

    function warn(iframeId, msg) {
      output('warn', iframeId, msg, !0);
    }

    function output(type, iframeId, msg, enabled) {
      !0 === enabled &&
        'object' == typeof window.console &&
        console[type](formatLogHeader(iframeId), msg);
    }

    function iFrameListener(event) {
      function resizeIFrame() {
        function resize() {
          setSize(messageData),
            setPagePosition(iframeId),
            callback('resizedCallback', messageData);
        }

        ensureInRange('Height'),
          ensureInRange('Width'),
          syncResize(resize, messageData, 'init');
      }

      function processMsg() {
        var data = msg.substr(msgIdLen).split(':');
        return {
          iframe: settings[data[0]] && settings[data[0]].iframe,
          id: data[0],
          height: data[1],
          width: data[2],
          type: data[3],
        };
      }

      function ensureInRange(Dimension) {
        var max = Number(settings[iframeId]['max' + Dimension]),
          min = Number(settings[iframeId]['min' + Dimension]),
          dimension = Dimension.toLowerCase(),
          size = Number(messageData[dimension]);
        log(
          iframeId,
          'Checking ' + dimension + ' is in range ' + min + '-' + max,
        ),
          size < min &&
            ((size = min), log(iframeId, 'Set ' + dimension + ' to min value')),
          size > max &&
            ((size = max), log(iframeId, 'Set ' + dimension + ' to max value')),
          (messageData[dimension] = '' + size);
      }

      function isMessageFromIFrame() {
        function checkAllowedOrigin() {
          function checkList() {
            var i = 0,
              retCode = !1;
            for (
              log(
                iframeId,
                'Checking connection is from allowed list of origins: ' +
                  checkOrigin,
              );
              i < checkOrigin.length;
              i++
            )
              if (checkOrigin[i] === origin) {
                retCode = !0;
                break;
              }
            return retCode;
          }

          function checkSingle() {
            var remoteHost =
              settings[iframeId] && settings[iframeId].remoteHost;
            return (
              log(iframeId, 'Checking connection is from: ' + remoteHost),
              origin === remoteHost
            );
          }

          return checkOrigin.constructor === Array
            ? checkList()
            : checkSingle();
        }

        var origin = event.origin,
          checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
        if (checkOrigin && '' + origin != 'null' && !checkAllowedOrigin())
          throw new Error(
            'Unexpected message received from: ' +
              origin +
              ' for ' +
              messageData.iframe.id +
              '. Message was: ' +
              event.data +
              '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.',
          );
        return !0;
      }

      function isMessageForUs() {
        return (
          msgId === ('' + msg).substr(0, msgIdLen) &&
          msg.substr(msgIdLen).split(':')[0] in settings
        );
      }

      function isMessageFromMetaParent() {
        var retCode = messageData.type in { true: 1, false: 1, undefined: 1 };
        return (
          retCode &&
            log(iframeId, 'Ignoring init message from meta parent page'),
          retCode
        );
      }

      function getMsgBody(offset) {
        return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
      }

      function forwardMsgFromIFrame(msgBody) {
        log(
          iframeId,
          'MessageCallback passed: {iframe: ' +
            messageData.iframe.id +
            ', message: ' +
            msgBody +
            '}',
        ),
          callback('messageCallback', {
            iframe: messageData.iframe,
            message: JSON.parse(msgBody),
          }),
          log(iframeId, '--');
      }

      function getPageInfo() {
        var bodyPosition = document.body.getBoundingClientRect(),
          iFramePosition = messageData.iframe.getBoundingClientRect();
        return JSON.stringify({
          iframeHeight: iFramePosition.height,
          iframeWidth: iFramePosition.width,
          clientHeight: Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0,
          ),
          clientWidth: Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0,
          ),
          offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
          offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
          scrollTop: window.pageYOffset,
          scrollLeft: window.pageXOffset,
        });
      }

      function sendPageInfoToIframe(iframe, iframeId) {
        function debouncedTrigger() {
          trigger(
            'Send Page Info',
            'pageInfo:' + getPageInfo(),
            iframe,
            iframeId,
          );
        }

        debounceFrameEvents(debouncedTrigger, 32, iframeId);
      }

      function startPageInfoMonitor() {
        function setListener(type, func) {
          function sendPageInfo() {
            settings[id]
              ? sendPageInfoToIframe(settings[id].iframe, id)
              : stop();
          }

          ['scroll', 'resize'].forEach(function (evt) {
            log(id, type + evt + ' listener for sendPageInfo'),
              func(window, evt, sendPageInfo);
          });
        }

        function stop() {
          setListener('Remove ', removeEventListener);
        }

        function start() {
          setListener('Add ', addEventListener);
        }

        var id = iframeId;
        start(), settings[id] && (settings[id].stopPageInfo = stop);
      }

      function stopPageInfoMonitor() {
        settings[iframeId] &&
          settings[iframeId].stopPageInfo &&
          (settings[iframeId].stopPageInfo(),
          delete settings[iframeId].stopPageInfo);
      }

      function checkIFrameExists() {
        var retBool = !0;
        return (
          null === messageData.iframe &&
            (warn(iframeId, 'IFrame (' + messageData.id + ') not found'),
            (retBool = !1)),
          retBool
        );
      }

      function getElementPosition(target) {
        var iFramePosition = target.getBoundingClientRect();
        return (
          getPagePosition(iframeId),
          {
            x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
            y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y)),
          }
        );
      }

      function scrollRequestFromChild(addOffset) {
        function reposition() {
          (pagePosition = newPosition), scrollTo(), log(iframeId, '--');
        }

        function calcOffset() {
          return {
            x: Number(messageData.width) + offset.x,
            y: Number(messageData.height) + offset.y,
          };
        }

        function scrollParent() {
          window.parentIFrame
            ? window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](
                newPosition.x,
                newPosition.y,
              )
            : warn(
                iframeId,
                'Unable to scroll to requested position, window.parentIFrame not found',
              );
        }

        var offset = addOffset
            ? getElementPosition(messageData.iframe)
            : { x: 0, y: 0 },
          newPosition = calcOffset();
        log(
          iframeId,
          'Reposition requested from iFrame (offset x:' +
            offset.x +
            ' y:' +
            offset.y +
            ')',
        ),
          window.top !== window.self ? scrollParent() : reposition();
      }

      function scrollTo() {
        !1 !== callback('scrollCallback', pagePosition)
          ? setPagePosition(iframeId)
          : unsetPagePosition();
      }

      function findTarget(location) {
        function jumpToTarget() {
          var jumpPosition = getElementPosition(target);
          log(
            iframeId,
            'Moving to in page link (#' +
              hash +
              ') at x: ' +
              jumpPosition.x +
              ' y: ' +
              jumpPosition.y,
          ),
            (pagePosition = { x: jumpPosition.x, y: jumpPosition.y }),
            scrollTo(),
            log(iframeId, '--');
        }

        function jumpToParent() {
          window.parentIFrame
            ? window.parentIFrame.moveToAnchor(hash)
            : log(
                iframeId,
                'In page link #' +
                  hash +
                  ' not found and window.parentIFrame not found',
              );
        }

        var hash = location.split('#')[1] || '',
          hashData = decodeURIComponent(hash),
          target =
            document.getElementById(hashData) ||
            document.getElementsByName(hashData)[0];
        target
          ? jumpToTarget()
          : window.top !== window.self
            ? jumpToParent()
            : log(iframeId, 'In page link #' + hash + ' not found');
      }

      function callback(funcName, val) {
        return chkCallback(iframeId, funcName, val);
      }

      function actionMsg() {
        switch (
          (settings[iframeId] && settings[iframeId].firstRun && firstRun(),
          messageData.type)
        ) {
          case 'close':
            settings[iframeId].closeRequestCallback
              ? chkCallback(
                  iframeId,
                  'closeRequestCallback',
                  settings[iframeId].iframe,
                )
              : closeIFrame(messageData.iframe);
            break;
          case 'message':
            forwardMsgFromIFrame(getMsgBody(6));
            break;
          case 'scrollTo':
            scrollRequestFromChild(!1);
            break;
          case 'scrollToOffset':
            scrollRequestFromChild(!0);
            break;
          case 'pageInfo':
            sendPageInfoToIframe(
              settings[iframeId] && settings[iframeId].iframe,
              iframeId,
            ),
              startPageInfoMonitor();
            break;
          case 'pageInfoStop':
            stopPageInfoMonitor();
            break;
          case 'inPageLink':
            findTarget(getMsgBody(9));
            break;
          case 'reset':
            resetIFrame(messageData);
            break;
          case 'init':
            resizeIFrame(), callback('initCallback', messageData.iframe);
            break;
          default:
            resizeIFrame();
        }
      }

      function hasSettings(iframeId) {
        var retBool = !0;
        return (
          settings[iframeId] ||
            ((retBool = !1),
            warn(
              messageData.type +
                ' No settings for ' +
                iframeId +
                '. Message was: ' +
                msg,
            )),
          retBool
        );
      }

      function iFrameReadyMsgReceived() {
        for (var iframeId in settings)
          trigger(
            'iFrame requested init',
            createOutgoingMsg(iframeId),
            document.getElementById(iframeId),
            iframeId,
          );
      }

      function firstRun() {
        settings[iframeId] && (settings[iframeId].firstRun = !1);
      }

      var msg = event.data,
        messageData = {},
        iframeId = null;
      '[iFrameResizerChild]Ready' === msg
        ? iFrameReadyMsgReceived()
        : isMessageForUs()
          ? ((messageData = processMsg()),
            (iframeId = logId = messageData.id),
            settings[iframeId] && (settings[iframeId].loaded = !0),
            !isMessageFromMetaParent() &&
              hasSettings(iframeId) &&
              (log(iframeId, 'Received: ' + msg),
              checkIFrameExists() && isMessageFromIFrame() && actionMsg()))
          : info(iframeId, 'Ignored: ' + msg);
    }

    function chkCallback(iframeId, funcName, val) {
      var func = null,
        retVal = null;
      if (settings[iframeId]) {
        if ('function' != typeof (func = settings[iframeId][funcName]))
          throw new TypeError(
            funcName + ' on iFrame[' + iframeId + '] is not a function',
          );
        retVal = func(val);
      }
      return retVal;
    }

    function closeIFrame(iframe) {
      var iframeId = iframe.id;
      log(iframeId, 'Removing iFrame: ' + iframeId),
        iframe.parentNode && iframe.parentNode.removeChild(iframe),
        chkCallback(iframeId, 'closedCallback', iframeId),
        log(iframeId, '--'),
        delete settings[iframeId];
    }

    function getPagePosition(iframeId) {
      null === pagePosition &&
        ((pagePosition = {
          x:
            window.pageXOffset !== undefined
              ? window.pageXOffset
              : document.documentElement.scrollLeft,
          y:
            window.pageYOffset !== undefined
              ? window.pageYOffset
              : document.documentElement.scrollTop,
        }),
        log(
          iframeId,
          'Get page position: ' + pagePosition.x + ',' + pagePosition.y,
        ));
    }

    function setPagePosition(iframeId) {
      null !== pagePosition &&
        (window.scrollTo(pagePosition.x, pagePosition.y),
        log(
          iframeId,
          'Set page position: ' + pagePosition.x + ',' + pagePosition.y,
        ),
        unsetPagePosition());
    }

    function unsetPagePosition() {
      pagePosition = null;
    }

    function resetIFrame(messageData) {
      function reset() {
        setSize(messageData),
          trigger('reset', 'reset', messageData.iframe, messageData.id);
      }

      log(
        messageData.id,
        'Size reset requested by ' +
          ('init' === messageData.type ? 'host page' : 'iFrame'),
      ),
        getPagePosition(messageData.id),
        syncResize(reset, messageData, 'reset');
    }

    function setSize(messageData) {
      function setDimension(dimension) {
        (messageData.iframe.style[dimension] = messageData[dimension] + 'px'),
          log(
            messageData.id,
            'IFrame (' +
              iframeId +
              ') ' +
              dimension +
              ' set to ' +
              messageData[dimension] +
              'px',
          );
      }

      function chkZero(dimension) {
        hiddenCheckEnabled ||
          '0' !== messageData[dimension] ||
          ((hiddenCheckEnabled = !0),
          log(iframeId, 'Hidden iFrame detected, creating visibility listener'),
          fixHiddenIFrames());
      }

      function processDimension(dimension) {
        setDimension(dimension), chkZero(dimension);
      }

      var iframeId = messageData.iframe.id;
      settings[iframeId] &&
        (settings[iframeId].sizeHeight && processDimension('height'),
        settings[iframeId].sizeWidth && processDimension('width'));
    }

    function syncResize(func, messageData, doNotSync) {
      doNotSync !== messageData.type && requestAnimationFrame
        ? (log(messageData.id, 'Requesting animation frame'),
          requestAnimationFrame(func))
        : func();
    }

    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
      function postMessageToIFrame() {
        var target = settings[id] && settings[id].targetOrigin;
        log(
          id,
          '[' +
            calleeMsg +
            '] Sending msg to iframe[' +
            id +
            '] (' +
            msg +
            ') targetOrigin: ' +
            target,
        ),
          iframe.contentWindow.postMessage(msgId + msg, target);
      }

      function iFrameNotFound() {
        warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
      }

      function chkAndSend() {
        iframe && 'contentWindow' in iframe && null !== iframe.contentWindow
          ? postMessageToIFrame()
          : iFrameNotFound();
      }

      function warnOnNoResponse() {
        function warning() {
          !settings[id] ||
            settings[id].loaded ||
            errorShown ||
            ((errorShown = !0),
            warn(
              id,
              'IFrame has not responded within ' +
                settings[id].warningTimeout / 1e3 +
                ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ingored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.',
            ));
        }

        noResponseWarning &&
          settings[id] &&
          settings[id].warningTimeout &&
          (settings[id].msgTimeout = setTimeout(
            warning,
            settings[id].warningTimeout,
          ));
      }

      var errorShown = !1;
      (id = id || iframe.id),
        settings[id] && (chkAndSend(), warnOnNoResponse());
    }

    function createOutgoingMsg(iframeId) {
      return (
        iframeId +
        ':' +
        settings[iframeId].bodyMarginV1 +
        ':' +
        settings[iframeId].sizeWidth +
        ':' +
        settings[iframeId].log +
        ':' +
        settings[iframeId].interval +
        ':' +
        settings[iframeId].enablePublicMethods +
        ':' +
        settings[iframeId].autoResize +
        ':' +
        settings[iframeId].bodyMargin +
        ':' +
        settings[iframeId].heightCalculationMethod +
        ':' +
        settings[iframeId].bodyBackground +
        ':' +
        settings[iframeId].bodyPadding +
        ':' +
        settings[iframeId].tolerance +
        ':' +
        settings[iframeId].inPageLinks +
        ':' +
        settings[iframeId].resizeFrom +
        ':' +
        settings[iframeId].widthCalculationMethod
      );
    }

    function setupIFrame(iframe, options) {
      function setLimits() {
        function addStyle(style) {
          1 / 0 !== settings[iframeId][style] &&
            0 !== settings[iframeId][style] &&
            ((iframe.style[style] = settings[iframeId][style] + 'px'),
            log(
              iframeId,
              'Set ' + style + ' = ' + settings[iframeId][style] + 'px',
            ));
        }

        function chkMinMax(dimension) {
          if (
            settings[iframeId]['min' + dimension] >
            settings[iframeId]['max' + dimension]
          )
            throw new Error(
              'Value for min' +
                dimension +
                ' can not be greater than max' +
                dimension,
            );
        }

        chkMinMax('Height'),
          chkMinMax('Width'),
          addStyle('maxHeight'),
          addStyle('minHeight'),
          addStyle('maxWidth'),
          addStyle('minWidth');
      }

      function newId() {
        var id = (options && options.id) || defaults.id + count++;
        return null !== document.getElementById(id) && (id += count++), id;
      }

      function ensureHasId(iframeId) {
        return (
          (logId = iframeId),
          '' === iframeId &&
            ((iframe.id = iframeId = newId()),
            (logEnabled = (options || {}).log),
            (logId = iframeId),
            log(
              iframeId,
              'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')',
            )),
          iframeId
        );
      }

      function setScrolling() {
        switch (
          (log(
            iframeId,
            'IFrame scrolling ' +
              (settings[iframeId] && settings[iframeId].scrolling
                ? 'enabled'
                : 'disabled') +
              ' for ' +
              iframeId,
          ),
          (iframe.style.overflow =
            !1 === (settings[iframeId] && settings[iframeId].scrolling)
              ? 'hidden'
              : 'auto'),
          settings[iframeId] && settings[iframeId].scrolling)
        ) {
          case !0:
            iframe.scrolling = 'yes';
            break;
          case !1:
            iframe.scrolling = 'no';
            break;
          default:
            iframe.scrolling = settings[iframeId]
              ? settings[iframeId].scrolling
              : 'no';
        }
      }

      function setupBodyMarginValues() {
        ('number' !=
          typeof (settings[iframeId] && settings[iframeId].bodyMargin) &&
          '0' !== (settings[iframeId] && settings[iframeId].bodyMargin)) ||
          ((settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin),
          (settings[iframeId].bodyMargin =
            settings[iframeId].bodyMargin + 'px'));
      }

      function checkReset() {
        var firstRun = settings[iframeId] && settings[iframeId].firstRun,
          resetRequertMethod =
            settings[iframeId] &&
            settings[iframeId].heightCalculationMethod in resetRequiredMethods;
        !firstRun &&
          resetRequertMethod &&
          resetIFrame({ iframe: iframe, height: 0, width: 0, type: 'init' });
      }

      function setupIFrameObject() {
        Function.prototype.bind &&
          settings[iframeId] &&
          (settings[iframeId].iframe.iFrameResizer = {
            close: closeIFrame.bind(null, settings[iframeId].iframe),
            resize: trigger.bind(
              null,
              'Window resize',
              'resize',
              settings[iframeId].iframe,
            ),
            moveToAnchor: function (anchor) {
              trigger(
                'Move to anchor',
                'moveToAnchor:' + anchor,
                settings[iframeId].iframe,
                iframeId,
              );
            },
            sendMessage: function (message) {
              (message = JSON.stringify(message)),
                trigger(
                  'Send Message',
                  'message:' + message,
                  settings[iframeId].iframe,
                  iframeId,
                );
            },
          });
      }

      function init(msg) {
        function iFrameLoaded() {
          trigger('iFrame.onload', msg, iframe, undefined, !0), checkReset();
        }

        addEventListener(iframe, 'load', iFrameLoaded),
          trigger('init', msg, iframe, undefined, !0);
      }

      function checkOptions(options) {
        if ('object' != typeof options)
          throw new TypeError('Options is not an object');
      }

      function copyOptions(options) {
        for (var option in defaults)
          defaults.hasOwnProperty(option) &&
            (settings[iframeId][option] = options.hasOwnProperty(option)
              ? options[option]
              : defaults[option]);
      }

      function getTargetOrigin(remoteHost) {
        return '' === remoteHost || 'file://' === remoteHost ? '*' : remoteHost;
      }

      function processOptions(options) {
        (options = options || {}),
          (settings[iframeId] = {
            firstRun: !0,
            iframe: iframe,
            remoteHost: iframe.src.split('/').slice(0, 3).join('/'),
          }),
          checkOptions(options),
          copyOptions(options),
          settings[iframeId] &&
            (settings[iframeId].targetOrigin =
              !0 === settings[iframeId].checkOrigin
                ? getTargetOrigin(settings[iframeId].remoteHost)
                : '*');
      }

      function beenHere() {
        return iframeId in settings && 'iFrameResizer' in iframe;
      }

      var iframeId = ensureHasId(iframe.id);
      beenHere()
        ? warn(iframeId, 'Ignored iFrame, already setup.')
        : (processOptions(options),
          setScrolling(),
          setLimits(),
          setupBodyMarginValues(),
          init(createOutgoingMsg(iframeId)),
          setupIFrameObject());
    }

    function debouce(fn, time) {
      null === timer &&
        (timer = setTimeout(function () {
          (timer = null), fn();
        }, time));
    }

    function debounceFrameEvents(fn, time, frameId) {
      frameTimer[frameId] ||
        (frameTimer[frameId] = setTimeout(function () {
          (frameTimer[frameId] = null), fn();
        }, time));
    }

    function fixHiddenIFrames() {
      function checkIFrames() {
        function checkIFrame(settingId) {
          function chkDimension(dimension) {
            return (
              '0px' ===
              (settings[settingId] &&
                settings[settingId].iframe.style[dimension])
            );
          }

          function isVisible(el) {
            return null !== el.offsetParent;
          }

          settings[settingId] &&
            isVisible(settings[settingId].iframe) &&
            (chkDimension('height') || chkDimension('width')) &&
            trigger(
              'Visibility change',
              'resize',
              settings[settingId].iframe,
              settingId,
            );
        }

        for (var settingId in settings) checkIFrame(settingId);
      }

      function mutationObserved(mutations) {
        log(
          'window',
          'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type,
        ),
          debouce(checkIFrames, 16);
      }

      function createMutationObserver() {
        var target = document.querySelector('body'),
          config = {
            attributes: !0,
            attributeOldValue: !1,
            characterData: !0,
            characterDataOldValue: !1,
            childList: !0,
            subtree: !0,
          };
        new MutationObserver(mutationObserved).observe(target, config);
      }

      var MutationObserver =
        window.MutationObserver || window.WebKitMutationObserver;
      MutationObserver && createMutationObserver();
    }

    function resizeIFrames(event) {
      function resize() {
        sendTriggerMsg('Window ' + event, 'resize');
      }

      log('window', 'Trigger event: ' + event), debouce(resize, 16);
    }

    function tabVisible() {
      function resize() {
        sendTriggerMsg('Tab Visable', 'resize');
      }

      'hidden' !== document.visibilityState &&
        (log('document', 'Trigger event: Visiblity change'),
        debouce(resize, 16));
    }

    function sendTriggerMsg(eventName, event) {
      function isIFrameResizeEnabled(iframeId) {
        return (
          settings[iframeId] &&
          'parent' === settings[iframeId].resizeFrom &&
          settings[iframeId].autoResize &&
          !settings[iframeId].firstRun
        );
      }

      for (var iframeId in settings)
        isIFrameResizeEnabled(iframeId) &&
          trigger(
            eventName,
            event,
            document.getElementById(iframeId),
            iframeId,
          );
    }

    function setupEventListeners() {
      addEventListener(window, 'message', iFrameListener),
        addEventListener(window, 'resize', function () {
          resizeIFrames('resize');
        }),
        addEventListener(document, 'visibilitychange', tabVisible),
        addEventListener(document, '-webkit-visibilitychange', tabVisible),
        addEventListener(window, 'focusin', function () {
          resizeIFrames('focus');
        }),
        addEventListener(window, 'focus', function () {
          resizeIFrames('focus');
        });
    }

    function factory() {
      function init(options, element) {
        function chkType() {
          if (!element.tagName)
            throw new TypeError('Object is not a valid DOM element');
          if ('IFRAME' !== element.tagName.toUpperCase())
            throw new TypeError(
              'Expected <IFRAME> tag, found <' + element.tagName + '>',
            );
        }

        element &&
          (chkType(), setupIFrame(element, options), iFrames.push(element));
      }

      function warnDeprecatedOptions(options) {
        options &&
          options.enablePublicMethods &&
          warn(
            'enablePublicMethods option has been removed, public methods are now always available in the iFrame',
          );
      }

      var iFrames;
      return (
        setupRequestAnimationFrame(),
        setupEventListeners(),
        function (options, target) {
          switch (
            ((iFrames = []), warnDeprecatedOptions(options), typeof target)
          ) {
            case 'undefined':
            case 'string':
              Array.prototype.forEach.call(
                document.querySelectorAll(target || 'iframe'),
                init.bind(undefined, options),
              );
              break;
            case 'object':
              init(options, target);
              break;
            default:
              throw new TypeError(
                'Unexpected data type (' + typeof target + ')',
              );
          }
          return iFrames;
        }
      );
    }

    function createJQueryPublicMethod($) {
      $.fn
        ? $.fn.iFrameResize ||
          ($.fn.iFrameResize = function (options) {
            function init(index, element) {
              setupIFrame(element, options);
            }

            return this.filter('iframe').each(init).end();
          })
        : info('', 'Unable to bind to jQuery, it is not fully loaded.');
    }

    if ('undefined' != typeof window) {
      var count = 0,
        logEnabled = !1,
        hiddenCheckEnabled = !1,
        msgHeader = 'message',
        msgHeaderLen = msgHeader.length,
        msgId = '[iFrameSizer]',
        msgIdLen = msgId.length,
        pagePosition = null,
        requestAnimationFrame = window.requestAnimationFrame,
        resetRequiredMethods = {
          max: 1,
          scroll: 1,
          bodyScroll: 1,
          documentElementScroll: 1,
        },
        settings = {},
        timer = null,
        logId = 'Host Page',
        defaults = {
          autoResize: !0,
          bodyBackground: null,
          bodyMargin: null,
          bodyMarginV1: 8,
          bodyPadding: null,
          checkOrigin: !0,
          inPageLinks: !1,
          enablePublicMethods: !0,
          heightCalculationMethod: 'bodyOffset',
          id: 'iFrameResizer',
          interval: 32,
          log: !1,
          maxHeight: 1 / 0,
          maxWidth: 1 / 0,
          minHeight: 0,
          minWidth: 0,
          resizeFrom: 'parent',
          scrolling: !1,
          sizeHeight: !0,
          sizeWidth: !1,
          warningTimeout: 5e3,
          tolerance: 0,
          widthCalculationMethod: 'scroll',
          closedCallback: function () {},
          initCallback: function () {},
          messageCallback: function () {
            warn('MessageCallback function not defined');
          },
          resizedCallback: function () {},
          scrollCallback: function () {
            return !0;
          },
        },
        frameTimer = {};
      window.jQuery && createJQueryPublicMethod(window.jQuery),
        'function' == typeof define && define.amd
          ? define([], factory)
          : 'object' == typeof module && 'object' == typeof module.exports
            ? (module.exports = factory())
            : (window.iFrameResize = window.iFrameResize || factory());
    }
  })();
